import { Helmet } from 'react-helmet';
import { IProduct } from '@interfaces';

export default function ProductMeta({ product }: { product?: IProduct }) {
    return (
        <>
            <Helmet>
                <title>{product.title}</title>
                <meta property="product:availability"
                    content={product?.status === 'instock'
                        ? 'in stock'
                        : 'out of stock'} />
                <meta property="product:price:amount" content={`${product.priceSubscribed}`} />
                <meta property="product:price:currency" content="USD" />
            </Helmet>
            <div itemScope itemType="http://schema.org/Product">
                <meta itemProp="name" content={product.title} />
                <meta itemProp="description" content={product.description} />
                <meta itemProp="productID" content={product.sku} />
                <meta itemProp="url" content={window.location.href} />
                <meta itemProp="image" content={product.mainImage} />
                <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
                    <link itemProp="availability" href={product?.status === 'instock'
                        ? 'in stock'
                        : 'out of stock'} />
                    <meta itemProp="price" content={`${product.priceSubscribed}`} />
                    <meta itemProp="priceCurrency" content="USD" />
                </div>
            </div>
        </>
    );
}